import { values } from 'lodash'

import { createOptionsFromEnum } from '../utils/createOptionsFromEnum'

export const NOTIFICATION_SUBTYPE = {
  ALERT: 'ALERT',
  INCIDENT: 'INCIDENT',
}

export const NOTIFICATION_SUBTYPE_ARRAY = values(NOTIFICATION_SUBTYPE)

export const NOTIFICATION_SUBTYPE_OPTIONS = createOptionsFromEnum({
  values: NOTIFICATION_SUBTYPE_ARRAY,
  prefix: 'notificationSubType',
})
